<template>
  <div class="logs">
    <el-row type="flex">
      <el-col :span="24">
        <ra-card>
          <template slot="header">
            <h6>Logs</h6>
            <el-radio-group v-model="period" size="mini">
              <el-radio-button label="lastweek">Last week</el-radio-button>
              <el-radio-button label="yesterday">Yesterday</el-radio-button>
              <el-radio-button label="today">Today</el-radio-button>
              <el-radio-button label="thisweek">This week</el-radio-button>
              <el-radio-button label="custom">Custom</el-radio-button>
            </el-radio-group>
          </template>
          <template slot="content">
            <el-table :data="events" :empty-text="'No events'">
              <el-table-column prop="name">
                <template slot="header">
                  <span class="ra-table--header">
                    Event name
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="date">
                <template slot="header">
                  <span class="ra-table--header">
                    Time
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </ra-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiConstants from "@/apiConstants";
import * as mutations from "@/store/mutation-types";

export default {
  name: "AuthXLogs",
  data() {
    return {
      routes: [
        {
          name: "authx.index",
          label: "AuthX"
        },
        {
          name: "authx.apps",
          label: "Applications"
        },
        {
          name: "authx.apps.overview",
          label: "Application Name"
        },
        {
          name: "authx.apps.logs",
          label: "Logs"
        }
      ],
      period: "today",
      events: [
        {
          name: "Updated Profile",
          time: "30 minutes ago"
        },
        {
          name: "Logged In",
          time: "2 hours"
        },
        {
          name: "Signed Up",
          time: "2 hours"
        }
      ]
    };
  },
  computed: {
    appId() {
      return this.$route.params.id;
    },
    app() {
      return this.$store.getters.authx_app;
    }
  },

  created() {
    if (!this.app.name) {
      this.getApp();
    }
  },

  methods: {
    getApp() {
      const apiUrl = `apps/${this.appId}`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            const { code } = resData;
            this.appCode = code;
            this.setAuthxApp(resData);
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },
    setAuthxApp(data) {
      this.$store.commit(mutations.SET_AUTHX_APP, data);
    }
  }
};
</script>

<style lang="scss" scoped>
.logs {
  .el-table {
    padding: 0;
    margin-top: 30px;
  }
}
</style>
